import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Guia } from "src/app/models/Guia";
import { HistoricoAtualizacoes } from "src/app/models/HistoricoAtualizacoes";
import { UsuarioEstatisticasService } from "src/app/services/data-services/usuario.estatisticas.service";
import { UsuarioGuiasService } from "src/app/services/data-services/usuario.guias.service";
import { HistoricoAtualizacoesService } from "src/app/services/historico-atualizacoes.service";
import { SimNaoDialogComponent } from "../../dialogs/sim-nao-dialog/sim-nao-dialog.component";
import { EnumTipoDataControle } from "src/app/enums/EnumDataControle";
import { DataControleRepositorio } from "src/app/repositorios/dataControle.repositorio";
import { Observable, of } from "rxjs";
import { ErrorHandlerService } from "src/app/services/errorHandler.service";
import { DataControle } from "src/app/models/dataControle";

@Component({
  selector: "app-historico-atualizacoes-dialog",
  templateUrl: "./historico-atualizacoes-dialog.component.html",
  styleUrls: ["./historico-atualizacoes-dialog.component.scss"],
})
export class HistoricoAtualizacoesDialogComponent implements OnInit {
  public historicoAtualizacoesReferencia$: Observable<HistoricoAtualizacoes[]> =
    of([]);
  public historicoAtualizacoesComentarios$: Observable<
    HistoricoAtualizacoes[]
  > = of([]);
  public historicoAtualizacoesLeis$: Observable<HistoricoAtualizacoes[]> = of(
    []
  );
  public historicoAtualizacoes$: Observable<HistoricoAtualizacoes[]> = of([]);

  constructor(
    public dialogRef: MatDialogRef<HistoricoAtualizacoesDialogComponent>,
    private usuarioEstatisticasService: UsuarioEstatisticasService,
    private usuarioGuiasService: UsuarioGuiasService,
    private historicoAtualizacoesService: HistoricoAtualizacoesService,
    public dialog: MatDialog,
    private dataControleRepositorio: DataControleRepositorio,
    private errorHandlerService: ErrorHandlerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.historicoAtualizacoes$ =
      this.historicoAtualizacoesService.getHistoricoAtualizacoesAll();

    this.historicoAtualizacoesLeis$ =
      this.historicoAtualizacoesService.getHistoricoAtualizacoesLeis();

    this.historicoAtualizacoesReferencia$ =
      this.historicoAtualizacoesService.getHistoricoAtualizacoesReferencias();

    this.historicoAtualizacoesComentarios$ =
      this.historicoAtualizacoesService.getHistoricoAtualizacoesComentarios();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  async abrirEmNovaGuia(tituloLei: string, idLei: string, idItem: string) {
    const guia = new Guia();
    guia.idLei = idLei;
    guia.titulo = tituloLei;

    await this.usuarioEstatisticasService.alterarPosicaoLeitura(idLei, idItem);
    await this.usuarioGuiasService.novaGuia(guia);
    this.onCancel();
  }

  public confirmarCloseHistorico() {
    const dialogRef = this.dialog.open(SimNaoDialogComponent, {
      width: "250px",
      data: "Deseja limpar notificações?",
    });
    dialogRef.afterClosed().subscribe((result) => {
      const dataControle: DataControle = {
        tipo: EnumTipoDataControle.DataVisualizacaoNovidades,
        data: new Date(),
        id: EnumTipoDataControle.DataVisualizacaoNovidades.valueOf().toString(),
        dataHoraModificacao: new Date(),
        removido: false,
      };
      if (result) {
        this.dataControleRepositorio
          .salvar(dataControle)
          .then(() => {})
          .catch((error) => this.errorHandlerService.handleError(error));
      }
      this.onCancel();
    });
  }
}
